/**
 * @fileoverview gRPC-Web generated client stub for configepb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v4.23.4
// source: external/config/config.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var xcommon_common_pb = require('../../xcommon/common_pb.js')
const proto = {};
proto.configepb = require('./config_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.configepb.ConfigClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.configepb.ConfigPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.configepb.GetReleaseReq,
 *   !proto.configepb.GetReleaseResp>}
 */
const methodDescriptor_Config_GetRelease = new grpc.web.MethodDescriptor(
  '/configepb.Config/GetRelease',
  grpc.web.MethodType.UNARY,
  proto.configepb.GetReleaseReq,
  proto.configepb.GetReleaseResp,
  /**
   * @param {!proto.configepb.GetReleaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.configepb.GetReleaseResp.deserializeBinary
);


/**
 * @param {!proto.configepb.GetReleaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.configepb.GetReleaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.configepb.GetReleaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.configepb.ConfigClient.prototype.getRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/configepb.Config/GetRelease',
      request,
      metadata || {},
      methodDescriptor_Config_GetRelease,
      callback);
};


/**
 * @param {!proto.configepb.GetReleaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.configepb.GetReleaseResp>}
 *     Promise that resolves to the response
 */
proto.configepb.ConfigPromiseClient.prototype.getRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/configepb.Config/GetRelease',
      request,
      metadata || {},
      methodDescriptor_Config_GetRelease);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.configepb.ItemCUReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_Config_CreateOrUpdateItem = new grpc.web.MethodDescriptor(
  '/configepb.Config/CreateOrUpdateItem',
  grpc.web.MethodType.UNARY,
  proto.configepb.ItemCUReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.configepb.ItemCUReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.configepb.ItemCUReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.configepb.ConfigClient.prototype.createOrUpdateItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/configepb.Config/CreateOrUpdateItem',
      request,
      metadata || {},
      methodDescriptor_Config_CreateOrUpdateItem,
      callback);
};


/**
 * @param {!proto.configepb.ItemCUReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.configepb.ConfigPromiseClient.prototype.createOrUpdateItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/configepb.Config/CreateOrUpdateItem',
      request,
      metadata || {},
      methodDescriptor_Config_CreateOrUpdateItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.configepb.ItemDelReq,
 *   !proto.xcommon.CommonOut>}
 */
const methodDescriptor_Config_DeleteItem = new grpc.web.MethodDescriptor(
  '/configepb.Config/DeleteItem',
  grpc.web.MethodType.UNARY,
  proto.configepb.ItemDelReq,
  xcommon_common_pb.CommonOut,
  /**
   * @param {!proto.configepb.ItemDelReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  xcommon_common_pb.CommonOut.deserializeBinary
);


/**
 * @param {!proto.configepb.ItemDelReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.xcommon.CommonOut)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.xcommon.CommonOut>|undefined}
 *     The XHR Node Readable Stream
 */
proto.configepb.ConfigClient.prototype.deleteItem =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/configepb.Config/DeleteItem',
      request,
      metadata || {},
      methodDescriptor_Config_DeleteItem,
      callback);
};


/**
 * @param {!proto.configepb.ItemDelReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.xcommon.CommonOut>}
 *     Promise that resolves to the response
 */
proto.configepb.ConfigPromiseClient.prototype.deleteItem =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/configepb.Config/DeleteItem',
      request,
      metadata || {},
      methodDescriptor_Config_DeleteItem);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.configepb.PublishReleaseReq,
 *   !proto.configepb.PublishReleaseResp>}
 */
const methodDescriptor_Config_PublishRelease = new grpc.web.MethodDescriptor(
  '/configepb.Config/PublishRelease',
  grpc.web.MethodType.UNARY,
  proto.configepb.PublishReleaseReq,
  proto.configepb.PublishReleaseResp,
  /**
   * @param {!proto.configepb.PublishReleaseReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.configepb.PublishReleaseResp.deserializeBinary
);


/**
 * @param {!proto.configepb.PublishReleaseReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.configepb.PublishReleaseResp)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.configepb.PublishReleaseResp>|undefined}
 *     The XHR Node Readable Stream
 */
proto.configepb.ConfigClient.prototype.publishRelease =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/configepb.Config/PublishRelease',
      request,
      metadata || {},
      methodDescriptor_Config_PublishRelease,
      callback);
};


/**
 * @param {!proto.configepb.PublishReleaseReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.configepb.PublishReleaseResp>}
 *     Promise that resolves to the response
 */
proto.configepb.ConfigPromiseClient.prototype.publishRelease =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/configepb.Config/PublishRelease',
      request,
      metadata || {},
      methodDescriptor_Config_PublishRelease);
};


module.exports = proto.configepb;

